import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { getFirstCalendar } from '@ordersnproducts/modules/order-builder/reducers';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { SelectOptionI } from '../../../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '../../../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { BOOM_PUMP, BOOM_PUMP_CODE } from '../../../rms-specification/constants/pumps';
import { SpecFieldNames } from '../../constants/specification-field-names.enum';
import { SpecificationFormState } from '../../reducers/specification/specification.reducer';
import { UnloadTypePumpCodes } from '@ordersnproducts/modules/shared/models/pump-type.enum';

@Injectable()
export class PumpLengthOptionLoader implements SelectOptionLoaderI {
  constructor(protected store: Store<SpecificationFormState>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    if (this.isBoomPump(formGroup)) {
      // Get options from api repsonse (store)
      return this.store.select(getFirstCalendar).pipe(
        take(1),
        map((calendar) => {
          const placingBoomPump = calendar.pump.unloadMethods.find(
            (method) => method.unloadMethodCode === BOOM_PUMP_CODE,
          );
          return placingBoomPump.listPumpLength.map((item) => {
            return {
              id: item.length,
              name: `${item.length}`,
            };
          });
        }),
      );
    } else {
      return of([]);
    }
  }

  isBoomPump(formGroup: UntypedFormGroup) {
    return formGroup.get(SpecFieldNames.UNLOAD_TYPE).value === BOOM_PUMP;
  }
}

/**
 * This loader is used in the specification form
 * It loads the pump length options from the store
 * It is used when the pump capacity is specific pump
 */
@Injectable()
export class PumpLengthOptionLoaderUL implements SelectOptionLoaderI {
  constructor(protected store: Store<SpecificationFormState>) {}

  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    if (this.isSpecificPump(formGroup)) {
      // Get options from api repsonse (store)
      return this.store.select(getFirstCalendar).pipe(
        filter((calendar) => !!calendar),
        take(1),
        map(calendar => {
          const placingBoomPump = calendar.pump.unloadMethods.find(
            method => method.unloadMethodCode === BOOM_PUMP_CODE,
          );
          return placingBoomPump.listPumpLength.map(item => {
            return {
              id: item.length,
              name: `${item.length}`,
            };
          });
        }),
      );
    } else {
      return of([]);
    }
  }

  isSpecificPump(formGroup: UntypedFormGroup) {
    return formGroup.get(SpecFieldNames.PUMP).value === UnloadTypePumpCodes.SPECIFIC_PUMP;
  }
}
